
export default {
  name: "ProductLabel",
  props: {
    css: {
      type: Object,
      default: () => ({})
    },
    merchantId: {
      type: Number,
      default: null
    }
  },
  computed: {
    labelStyle() {
      const style = {
        height: "0.14rem",
        fontSize: "0.1rem",
        lineHeight: "0.12rem"
      }
      return Object.assign(style, this.css)
    }
  },
  methods: {
    regionExclusive() {
      return {
        0: this.$t("productLabel.HK_EXC"),
        1: this.$t("productLabel.MO_EXC")
      }[this.merchantId]
    }
  }
}
